var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Result } from '../result';
import { GpfError } from '../rest/GpfError';
import { handleResult } from './ImplDetailsHandleResult';
import { FetchResult } from './types';
import { csrfHeader } from './csrf';
import { getLocale } from '../locale';
import { correlationIdHeader } from './correlationId';
import { sessionIdHeader } from './sessionId';
/**
 * Get or post data using fetch
 *
 * Usage:
 *
 * ```
 * fetchWrapper<Customer>('/api/customer/').then(res => {
 *     if (res.isOk()) {
 *         console.log('Customer:', res.value);
 *     } else {
 *         console.error('Something went wrong:', res.error);
 *     }
 * });
 * ```
 *
 * @param url URL to fetch from
 * @param method type
 * @param body Request body to POST. If no body is provided, HTTP GET is used.
 * @param postProcessor Post-processing after JSON.parse on the result from the server. E.g. {@link fieldwiseTransform} and validation.
 * @param additionalHeaders Additional headers to be sent with the request.
 */
export function fetchJson(url, method, body, postProcessor, additionalHeaders) {
    if (method === void 0) { method = 'GET'; }
    if (additionalHeaders === void 0) { additionalHeaders = {}; }
    return __awaiter(this, void 0, FetchResult, function () {
        var res, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, fetch(url, {
                            method: method,
                            credentials: 'same-origin',
                            headers: __assign(__assign(__assign(__assign(__assign({}, csrfHeader()), correlationIdHeader()), sessionIdHeader()), { Accept: 'application/json, */*', 'Content-Type': 'application/json', 'Accept-Language': getJavaLocale() }), additionalHeaders),
                            body: JSON.stringify(body),
                        })];
                case 1:
                    res = _a.sent();
                    return [2 /*return*/, handleResult(res, postProcessor)];
                case 2:
                    e_1 = _a.sent();
                    return [2 /*return*/, Result.err(new GpfError('FETCH_EXCEPTION', 'Nettverkskall feilet: ' + e_1.toString(), '500', 500))];
                case 3: return [2 /*return*/];
            }
        });
    });
}
/**
 * gpf-js-utils use underline between "lang_country".
 * Java, tomcat and browsers use dash -> "lang-country"
 */
export function getJavaLocale() {
    return getLocale().replace('_', '-');
}
